module.exports = "/fonts/tarra-logotype-d-2e31b16e480f0115a3c1b18bc8f3e5c5.svg";